module.exports = __webpack_public_path__ + "static/media/heart.4c755057.svg";